import { styled } from '@mui/material/styles';

export const Bullet = styled('span')(({ color }) => ({
	display: 'inline-block',
	varticalAlign: 'middle',
	width: 8,
	height: 8,
	borderRadius: '50%;',
	backgroundColor: color,
	marginRight: 8,
}));
